import React from 'react';
import {StyleProp, TextStyle} from 'react-native';
import {makeStyles} from '@rneui/themed';

import useStorePriceDisplayConditions from '../../hooks/usePriceDisplayConditions';
import {OrderLine} from '../../transport/apiServiceResponse';
import {getMemberPrice} from '../../utils/loyalty';
import {makeOriginalPriceText} from '../../utils/products';
import { getProductDisplayRules } from '../../utils/rewards';
import Text from '../themed/Text';

function SecondaryCalloutLabel({
  item,
  styles,
}: {
  item: OrderLine;
  styles?: StyleProp<TextStyle>;
}) {
  const {secondaryCalloutLabel: secondaryCallout} = useSecondaryCalloutLabels(
    item,
    {
      secondaryCalloutLabel: styles,
    },
  );

  return secondaryCallout;
}

export const useSecondaryCalloutLabels = (
  item: OrderLine,
  styles?: {
    secondaryCalloutLabel?: StyleProp<TextStyle>;
    originalPriceLabel?: StyleProp<TextStyle>;
    nonMemberPriceLabel?: StyleProp<TextStyle>;
  },
) => {
  const _styles = useStyles();
  const {showMemberPrice} = useStorePriceDisplayConditions();
  const productDisplayRules = getProductDisplayRules(item);

  const memberPrice = getMemberPrice(item);

  let originalPriceText = makeOriginalPriceText(item) || null;
  let nonMemberPriceText = null;

  if (
    (showMemberPrice.publicPricing &&
      memberPrice?.external_sell_type === 'public' &&
      productDisplayRules.presentAsPublicMemberProduct
    ) ||
    (showMemberPrice.privatePricing &&
      memberPrice?.external_sell_type === 'private' &&
      productDisplayRules.presentAsPrivateMemberProduct)
  ) {
    originalPriceText = null;
    nonMemberPriceText = 'Non-members Price';
  }

  return {
    secondaryCalloutLabel: (
      <Text style={styles?.secondaryCalloutLabel || _styles.nonMembersPrice}>
        {nonMemberPriceText || originalPriceText || ' '}
      </Text>
    ),
    originalPriceLabel: (
      <Text style={styles?.originalPriceLabel || _styles.nonMembersPrice}>
        {originalPriceText || ' '}
      </Text>
    ),
    nonMemberPriceLabel: (
      <Text style={styles?.nonMemberPriceLabel || _styles.nonMembersPrice}>
        {nonMemberPriceText || ' '}
      </Text>
    ),
  };
};

const useStyles = makeStyles(theme => {
  return {
    nonMembersPrice: {
      marginTop: 6,
      color: theme.colors.grey1,
      fontSize: theme.size.text.caption,
    },
  };
});

export default SecondaryCalloutLabel;
